import React from 'react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import LoadingPage from '../../components/LoadingPage';
import { useTranslation } from 'react-i18next';
import UnityLineChart from '../../components/UnityLineChart';
import UnityAverageChart from '../../components/UnityAverageChart';
import { redirectErrorPage } from '../../utils/errors';
import Intro from '../../components/common/Intro/Intro';
import Section from '../../components/common/Section/Section';

function PartiesUnity() {
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [options, setOptions] = useState(undefined);
    const { municipalitaId, bodyType, zastupitelstvoId } = useParams();
    const { t } = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responses = await axios.all([
                    axios.get(`${municipalitaId}/${bodyType}/${zastupitelstvoId}/PartiesUnity`),
                    axios.get(`FE/${municipalitaId}/${bodyType}/${zastupitelstvoId}/dropdownSubjectOptions`)
                ]);

                const data = responses[0].data;
                setData(data);
                setOptions(responses[1].data);
            } catch (error: any) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [municipalitaId, bodyType, zastupitelstvoId]);

    if (loading) {
        return <LoadingPage />;
    }

    if (error) {
        return redirectErrorPage(error);
    }
    if (data !== undefined && options !== undefined) {
        return (
            <>
                <Intro title={t('parties-voting-unity')} description={t('unity-tooltip', { ns: 'analyses' })} />
                <Section title={t('parties-voting-unity-meetings')}>
                    <UnityLineChart data={data} options={options} />
                </Section>
                <Section
                    title={t('parties-voting-avg-unity', { ns: 'translation' })}
                    subtitle={t('parties-voting-avg-unity-desc')}
                >
                    <UnityAverageChart data={data} />
                </Section>
            </>
        );
    } else {
        return <LoadingPage />;
    }
}

export default PartiesUnity;
